import { FILTER_OPTION_RESOURCE } from '../Shared/Filters/useFilterOptionFields';

export const AGENT_FILTER_OPTION_RESOURCES = {
    knowledge_base_id: FILTER_OPTION_RESOURCE.KNOWLEDGE_BASE,
    channel_id: FILTER_OPTION_RESOURCE.CHANNEL
};

const STARTABLE_CHANNEL_TYPES = new Set(['facebook_page']);

export const getInactiveChannels = (agent) => (
    (agent?.channels || []).filter(channel =>
        channel?.id
        && !channel.is_virtual
        && channel.is_synchronization_enabled === false
        && STARTABLE_CHANNEL_TYPES.has(channel.channel_type)
    )
);

export const getChannelDisplayName = (channel, t) => (
    channel?.name || channel?.external_channel_id || t('channel')
);
